import { render, staticRenderFns } from "./proofread.vue?vue&type=template&id=5f4cf64b&scoped=true&"
import script from "./proofread.vue?vue&type=script&lang=js&"
export * from "./proofread.vue?vue&type=script&lang=js&"
import style0 from "./proofread.vue?vue&type=style&index=0&id=5f4cf64b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cf64b",
  null
  
)

export default component.exports